import { RESOURCE_NAME } from '@esentai/core/features/parkingWhitelistGroups/consts';
import { canCreate, canRead, canUpdate } from '@esentai/core/policy-dsl';

import { authorizeIf } from '@/features/currentUser/rbac';

export const canReadWhitelistGroups = authorizeIf(canRead(RESOURCE_NAME));
export const canCreateWhitelistGroups = authorizeIf(canCreate(RESOURCE_NAME));
export const canUpdateWhitelistGroups = authorizeIf(canUpdate(RESOURCE_NAME));
